function centerVideos() {
    const iframes = document.getElementsByTagName("iframe");
    Array.prototype.forEach.call(iframes, frame => {
        frame.parentElement.style.textAlign = "center";
    });
}
function setSuperscript() {
    const pElements = document.getElementsByTagName("p");
    Array.prototype.forEach.call(pElements, p => {
        p.innerHTML = p.innerHTML.replace("®", "<sup>®</sup>");
    });
}
function splitPhotos(openingMarker, closingMarker, className) {
    const imageInstances = document.getElementsByTagName("img");
    let imagesElementsArray = [];
    let subjectsForRemoval = [];
    function retrieveTotalIndex(element) {
        return [...element.parentElement.children].indexOf(element); 
    }
    Array.prototype.forEach.call(imageInstances, image => {
        if (image.parentElement.localName === 'p') {
            if (retrieveTotalIndex(image.parentElement) > retrieveTotalIndex(openingMarker) && retrieveTotalIndex(image.parentElement) < retrieveTotalIndex(closingMarker)) imagesElementsArray.push(image), subjectsForRemoval.push(image.parentElement);
        }
    }); 
    const newImageContainer = document.createElement('div');
    newImageContainer.classList.add(className);
    openingMarker.insertAdjacentElement('beforebegin', newImageContainer);
    imagesElementsArray.forEach(image => newImageContainer.appendChild(image));
    subjectsForRemoval.push(openingMarker);
    subjectsForRemoval.push(closingMarker);
    subjectsForRemoval.forEach(element => element.remove());
}
function recognizeConsolidation(openingMarker, closingMarker) {
    const classKey = {
        "//**StartHalfImage**//":"half-image-container",
        "//**StartThreeQuarterImage**//":"tres-quatro-container"
    }
    splitPhotos(openingMarker, closingMarker, classKey[openingMarker.innerHTML]);

}
function halfPhotos() {
    const bodyCopyElements = document.getElementsByTagName('p');
    const startStrings = ["//**StartHalfImage**//", "//**StartThreeQuarterImage**//"];
    const stopStrings = ["//**StopHalfImage**//", "//**StopThreeQuarterImage**//"];
    let startElements = [];
    let stopElements = [];

    Array.prototype.forEach.call(bodyCopyElements, bodyCopyElement => {
        if (startStrings.some(startString => bodyCopyElement.innerHTML.includes(startString))) startElements.push(bodyCopyElement);
        else if (stopStrings.some(stopString => bodyCopyElement.innerHTML.includes(stopString))) stopElements.push(bodyCopyElement);
    }); 
    startElements.forEach((starter, i) => {
        recognizeConsolidation(starter, stopElements[i]);
    })
    
}
centerVideos();
setSuperscript();
halfPhotos();